import React, { ReactNode, useState, useEffect } from "react"
import Components from ".."
import { unified } from "unified"
import remarkParse from "remark-parse"
import remarkRehype from "remark-rehype"
import rehypeReact from "rehype-react"
import remarkReactComponents from "../../helpers/remarkReactComponents"
import { blokType } from "../../types"
import { LinkBlokProps } from "../link"

import {
  StyledHeroFullBleed,
  StyledHeroFullBleedContainer,
  StyledHeroFullBleedTitle,
  StyledHeroFullBleedDescription,
  StyledHeroFullBleedButtons,
  StyledHeroLogo,
} from "./partials"
import MediaCmp from "../s22_media/Media"

export interface HeroFullBleedProps {
  logo: blokType[]
  logoUrl: blokType[]
  title: string
  description: string
  cta_button: blokType[]
  image: blokType[]
  id: string,
  custom_id: string,
}

export const HeroFullBleedCmp: React.FC<HeroFullBleedProps> = ({
  logo,
  logoUrl,
  title,
  description,
  cta_button,
  image,
  id,
  custom_id,
}) => {
  // const [headerHeight, setHeaderHeight] = useState("0")

  // useEffect(() => {
  //   return setHeaderHeight(document.querySelector("#site-header").offsetHeight)
  // })

  return (
    <StyledHeroFullBleed data-name="hero-fullbleed" bg_image={image.filename} id={custom_id ? custom_id : id}>
      <StyledHeroFullBleedContainer>
        {logo &&
          logo.map((content: any) => (
            <StyledHeroLogo key={content._uid}>
              {logoUrl &&
                logoUrl.map((content) =>
                  React.createElement(Components(content.component), {
                    key: content._uid,
                    blok: content,
                  })
                )}

              <MediaCmp
                media={content.media}
                aspect_ratio={content.aspect_ratio}
                video_controls={content.video_controls}
                video_loop={content.video_loop}
                video_autoplay={content.video_autoplay}
                video_muted={content.video_muted}
                external_video={content.external_video}
                youvisit_url={content.youvisit_url}
                mobile_image={content.mobile_image}
                mobile_aspect_ratio={content.mobile_aspect_ratio}
              />
            </StyledHeroLogo>
          ))}
        {title && <StyledHeroFullBleedTitle>{title}</StyledHeroFullBleedTitle>}
        {description && (
          <StyledHeroFullBleedDescription>
            {
              unified()
                .use(remarkParse)
                .use(remarkRehype)
                .use(rehypeReact as any, {
                  createElement: React.createElement,
                  components: remarkReactComponents,
                  Fragment: React.Fragment
                })
                .processSync(description.replace(/\n/g, "  \n"))
                .result as ReactNode
            }
          </StyledHeroFullBleedDescription>
        )}
        {cta_button && cta_button.length > 0 && (
          <StyledHeroFullBleedButtons>
            {cta_button.map((content) =>
              React.createElement(Components(content.component), {
                key: content._uid,
                blok: content,
              })
            )}
          </StyledHeroFullBleedButtons>
        )}
      </StyledHeroFullBleedContainer>
    </StyledHeroFullBleed>
  )
}
